import WarningModal from 'components/WarningModal';
import React from 'react';

export interface OptOutModuleProps {
  isOpen: boolean;
  onClose: () => void;
  onPrimaryPress: () => void;
  onSecondaryPress: () => void;
}

const OptOutModule: React.FC<OptOutModuleProps> = props => {
  const {isOpen, onClose, onPrimaryPress, onSecondaryPress} = props;

  return (
    <WarningModal
      isOpen={isOpen}
      onClose={onClose}
      title="Are you sure?"
      body="By turning off two-step verification, access to many features of your Caesars Rewards experience will be restricted."
      primaryCTATitle="Yes, Turn Off"
      secondaryCTATitle="Nevermind, keep me secured"
      onPrimaryPress={onPrimaryPress}
      onSecondaryPress={onSecondaryPress}
    />
  );
};

export default OptOutModule;
